var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "calculator-form",
    { ref: "form", attrs: { title: _vm.title } },
    [
      _c(
        "v-layout",
        { attrs: { slot: "form", wrap: "" }, slot: "form" },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c("v-select", {
                staticClass: "title-branding custom-select",
                attrs: {
                  items: _vm.products,
                  label: "Plan type",
                  "item-text": "Name",
                  "item-value": "ProductMasterID",
                  filled: "",
                  rules: [
                    function(v) {
                      return !!v || "Plan type is required"
                    }
                  ],
                  disabled: _vm.checking
                },
                on: { change: _vm.updateClientProduct },
                model: {
                  value: _vm.client.product,
                  callback: function($$v) {
                    _vm.$set(_vm.client, "product", $$v)
                  },
                  expression: "client.product"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm12: "", md6: "" } },
            [
              _c("v-slider", {
                staticClass: "custom-slider",
                class: _vm.isMobile ? "" : "mt-6",
                attrs: {
                  "thumb-label": "always",
                  "thumb-size": 35,
                  min: _vm.age_range.min,
                  max: _vm.age_range.max,
                  disabled: _vm.checking,
                  "inverse-label": "",
                  label: _vm.client.age.toString(),
                  hint:
                    "Age (".toUpperCase() +
                    _vm.age_range.min +
                    "-" +
                    _vm.age_range.max +
                    ")",
                  "persistent-hint": "",
                  rules: [
                    function(v) {
                      return !!v || "Age is required"
                    },
                    function(v) {
                      return !isNaN(v) || "Age needs to be a number"
                    },
                    function(v) {
                      return (
                        v <= _vm.age_range.max ||
                        "Age cannot be more than " + _vm.age_range.max
                      )
                    },
                    function(v) {
                      return (
                        v >= _vm.age_range.min ||
                        "Age cannot be less than " + _vm.age_range.min
                      )
                    },
                    function(v) {
                      return (
                        (_vm.client.retire_age &&
                          _vm.client.retire_age - _vm.client.age > 5) ||
                        "Client within 5 years of retirement age"
                      )
                    }
                  ],
                  color: _vm.$vuetify.theme.dark ? "accent" : "primary"
                },
                model: {
                  value: _vm.client.age,
                  callback: function($$v) {
                    _vm.$set(_vm.client, "age", $$v)
                  },
                  expression: "client.age"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm12: "", md6: "" } },
            [
              _c("v-select", {
                staticClass: "title-branding custom-select",
                attrs: {
                  items: [60, 65],
                  label: "Retirement age",
                  filled: "",
                  rules: [
                    function(v) {
                      return !!v || "Retirement age is required"
                    }
                  ],
                  disabled: _vm.checking
                },
                on: { change: _vm.updateFormValidation },
                model: {
                  value: _vm.client.retire_age,
                  callback: function($$v) {
                    _vm.$set(_vm.client, "retire_age", $$v)
                  },
                  expression: "client.retire_age"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.kpError
        ? _c(
            "v-card-actions",
            [
              _c(
                "v-alert",
                {
                  staticClass: "w-full title-branding caption",
                  attrs: { type: "error", icon: "$mdiAlert" }
                },
                [_vm._v("\n            " + _vm._s(_vm.kpError) + "\n        ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card-actions",
        { attrs: { slot: "actions" }, slot: "actions" },
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "custom-button",
              attrs: {
                type: "button",
                color: "accent",
                disabled: !_vm.formIsValid,
                loading: _vm.checking,
                small: _vm.isMobile
              },
              on: { click: _vm.goToStepTwo }
            },
            [
              _vm._v("\n            Next\n            "),
              _c("v-icon", { attrs: { dark: "", small: "" } }, [
                _vm._v("\n                $mdiChevronRight\n            ")
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }